import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const episodes = [
  { part: 1, title: "What is ABCMP?", runtime: "18m", desc: "Introduction to the core philosophy.", img: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&q=80&w=1200" },
  { part: 2, title: "A & B — Direction + Color", runtime: "24m", desc: "Confirming the trend before entry.", img: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&q=80&w=1200" },
  { part: 3, title: "C & M — Candles + Moneyflow", runtime: "31m", desc: "Reading institutional volume footprints.", img: "https://images.unsplash.com/photo-1642543492481-44e81e391452?auto=format&fit=crop&q=80&w=1200" },
  { part: 4, title: "P — 78% Conviction", runtime: "22m", desc: "The final filter for sniper entries.", img: "https://images.unsplash.com/photo-1535320903710-d9938a44917a?auto=format&fit=crop&q=80&w=1200" }
];

const OriginalsRow = () => {
  return (
    <div className="w-full py-16 bg-[#050505] relative overflow-hidden border-y border-white/5 my-8">
      {/* Cinematic Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-[600px] bg-rocket/5 blur-[150px] pointer-events-none" />
      
      <div className="container mx-auto px-4 md:px-12 relative z-10">
        <div className="mb-10 text-center md:text-left flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <div className="flex items-center justify-center md:justify-start space-x-2 mb-2">
              <span className="text-rocket text-xl">
                <SafeIcon name="Monitor" className="w-5 h-5" />
              </span>
              <h4 className="text-rocket font-bold tracking-[0.2em] uppercase text-sm">RocketAlgo Original Series</h4>
            </div>
            <h2 className="text-[32px] md:text-[44px] font-black text-white leading-tight">The ABCMP Formula</h2>
            <p className="text-gray-400 mt-2 max-w-2xl text-sm md:text-base">
              The proprietary high-conviction trading framework powering RocketAlgo. 
              Learn the exact system our institutional traders use daily.
            </p>
          </div>
          <button className="hidden md:flex items-center space-x-2 bg-white/10 hover:bg-white/20 text-white px-5 py-2.5 rounded-full text-sm font-bold transition-colors backdrop-blur-md border border-white/10">
            <SafeIcon name="PlayCircle" className="w-5 h-5" />
            <span>Play Trailer</span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6">
          {episodes.map((ep, index) => (
            <motion.div
              key={ep.part}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative aspect-video md:aspect-[4/3] rounded-xl overflow-hidden cursor-pointer bg-dark-card border border-white/10"
            >
              <img 
                src={ep.img} 
                alt={ep.title} 
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110 opacity-60 group-hover:opacity-40"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
              
              <div className="absolute inset-0 p-6 flex flex-col justify-between z-10">
                <div className="flex justify-between items-start">
                  <span className="text-white text-5xl font-black opacity-30 group-hover:opacity-100 group-hover:text-rocket transition-all duration-500 drop-shadow-2xl">
                    0{ep.part}
                  </span>
                  <span className="bg-black/50 backdrop-blur-md text-white border border-white/10 text-xs font-semibold px-2.5 py-1 rounded">
                    {ep.runtime}
                  </span>
                </div>
                
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-xl font-bold text-white leading-tight drop-shadow-lg mb-1">
                    {ep.title}
                  </h3>
                  <p className="text-sm text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300 line-clamp-2">
                    {ep.desc}
                  </p>
                  
                  {/* Subtle Orange Neon Line */}
                  <div className="w-0 h-1 bg-rocket mt-4 rounded-full transition-all duration-500 group-hover:w-full shadow-[0_0_10px_rgba(255,102,0,0.8)]" />
                </div>
              </div>

              {/* Center Play Icon on Hover */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                <div className="w-16 h-16 rounded-full bg-rocket/90 text-white flex items-center justify-center shadow-[0_0_30px_rgba(255,102,0,0.6)] backdrop-blur-sm transform scale-50 group-hover:scale-100 transition-transform duration-300">
                  <SafeIcon name="Play" className="w-6 h-6 ml-1 fill-current" />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OriginalsRow;